import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import RootLanding from '../views/RootLanding.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: RootLanding
  },
  {
    path: '/live',
    name: 'live',
    // route level code-splitting
    // this generates a separate chunk (live.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "live" */ '../views/LiveView.vue')
  },
  {
    path: '/session/signup',
    name: 'session-signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/SignupView.vue')
  },
  {
    path: '/session/dashboard',
    name: 'session-dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/DashboardView.vue')
  },
  {
    path: '/session/signin',
    name: 'session-signin',
    component: () => import(/* webpackChunkName: "signin" */ '../views/SignInView.vue')
  },
  // Session sub-site routes (lazy-loaded)
  {
    path: '/session',
    name: 'session-home',
    component: () => import(/* webpackChunkName: "session-home" */ '../views/session/SessionHome.vue')
  },
  {
    path: '/session/sandbox',
    name: 'session-sandbox',
    component: () => import(/* webpackChunkName: "session-sandbox" */ '../views/session/SessionSandbox.vue')
  },
  {
    path: '/session/docs',
    name: 'session-docs',
    component: () => import(/* webpackChunkName: "session-docs" */ '../views/session/SessionDocs.vue')
  },
  {
    path: '/session/benchmarks',
    name: 'session-benchmarks',
    component: () => import(/* webpackChunkName: "session-benchmarks" */ '../views/session/SessionBenchmarks.vue')
  },
  {
    path: '/session/api',
    name: 'session-api',
    component: () => import(/* webpackChunkName: "session-api" */ '../views/session/SessionApiRef.vue')
  },
  {
    path: '/cases',
    name: 'FinanceCases',
    component: () => import(/* webpackChunkName: "cases" */ '../views/FinanceCases.vue')
  },
  {
    path: '/divergence',
    name: 'FinanceDivergence',
    component: () => import(/* webpackChunkName: "divergence" */ '../views/FinanceDivergence.vue')
  },
  // {
  //   path: '/alerts',
  //   name: 'alerts',
  //   component: () => import(/* webpackChunkName: "alerts" */ '../views/AlertsView.vue')
  // },
  // {
  //   path: '/divergence-old',
  //   name: 'divergence-old',
  //   component: () => import(/* webpackChunkName: "divergence_old" */ '../views/DivergenceView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    return { left: 0, top: 0 }
  }
})

// If the app is served on the session subdomain, rewrite top-level paths
// to the `/session` prefixed routes so `session.artrofimov.xyz/docs` -> `/session/docs`.
router.beforeEach((to, _from, next) => {
  try {
    const host = (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname : ''
    if (host.startsWith('session.')) {
      // If already under /session, continue.
      if (to.path === '/' ) {
        return next({ path: '/session' })
      }
      if (!to.path.startsWith('/session')) {
        return next({ path: '/session' + (to.path === '/' ? '' : to.path) })
      }
    }
  } catch (e) {
    // ignore in non-browser environments
  }
  return next()
})

export default router
